import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { useRecoilValue } from 'recoil';
import { LicenseInfo } from '@mui/x-license';

import SnackbarManager from 'components/common/Snackbar';
import ConfirmDialog from 'components/common/ConfirmDialog';
import { ModeAtom } from 'atoms/mode';
import { createThemeByMode } from 'common/theme';
import { setColorTheme } from 'utils/dom';
import { MUI_LICENSE_KEY } from 'common/config';

function Providers({ children }) {
  const mode = useRecoilValue(ModeAtom);
  const theme = createThemeByMode(mode);

  useEffect(() => {
    setColorTheme(mode);
    LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);
  }, [mode]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
        <SnackbarManager autoHideDuration={7000} />
        <ConfirmDialog />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

Providers.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any,
};

export default memo(Providers);
